/*
* @Author: hasee
* @Date:   2016-11-11 15:10:19
* @Last Modified by:   hasee
* @Last Modified time: 2016-12-08 17:08:06
*/
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);
// templates
import Index from './pages/Index'
import Question from './pages/question'
import Funreport from './pages/funreport'
import Sharereport from './pages/sharereport.vue'
import Proreport from './pages/proreport.vue'
import Download from './pages/download.vue'

const router = new VueRouter({
	routes :[
		{
			name: '',
			path: '/',
			component: Index
		},
		{
			name: 'index',
			path: '/index',
			component: Index
		},
		{
			name: 'question',
			path:'/question/:questionId',
			component: Question
		},
		{
			name: 'funreport',
			path: '/funreport',
			component: Funreport
		},
		{
			name: 'sharereport',
			path: '/sharereport/:reportId',
			component: Sharereport
		},
		{
			name: 'proreport',
			path: '/proreport/',
			component: Proreport
		},
		{
			name: 'download',
			path: '/download',
			component: Download
		},
		{ path: '*', redirect: '/index' }
	]
});
export default router;



// WEBPACK FOOTER //
// ./src/router.js